module.exports = __webpack_public_path__ + "img/icon-cross-button.c73bc946.svg";